<template>
  <div>
    <h1>Federated Floor</h1>
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <ul v-else>
      <li v-for="article in articles" :key="article.id">
        <h2>{{ article.Title }}</h2>
        <p>Abstract: <i v-html="article.Abstract"></i></p>
        <p id="author">Author: {{ article.AuthorName }}</p>
        <p>Published on: {{ article.CreatedAt }}</p>
        <p id="cid">CID: <a :href="`https://ipfs.io/ipfs/${article.CID}`">{{ article.CID }}</a></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'ArticleList',
  setup() {
    const articles = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const fetchArticles = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/articles/federated`); // Replace with your actual API endpoint
        if (!response.ok) {
          throw new Error('Failed to fetch articles');
        }
        const data = await response.json();
        articles.value = data;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchArticles);

    return {
      articles,
      loading,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
